<template lang="pug">
form(class='file-upload' ref='form')
  div(class='file-upload-wrap')
    v-text-field(
      :label='label'
      v-model='name'
      prepend-icon='attach_file'
      hint='Максимальный размер файла 60Мб'
      persistent-hint
    )
    input(@change='read' accept='image/*' type='file' ref='image')
    div(v-if='value.url' class='file')
      div(class='name')
        div(class='file-name')
          a(:href='value.url' target='_blank') {{value.url}}
        div(class="file-preview")
          img(:src="value.url")
          div(class="file-remove")
            a(@click.stop='remove') Удалить
  v-dialog(
    v-model='busy'
    persistent
    width='280'
  )
    v-card(color='primary' dark)
      v-card-text Загрузка файла
      v-progress-linear(v-model="progress" color='white' class='mb-0')
</template>

<script>
import http from '@/http'

export default {
  props: {
    label: {
      type: String,
      default: 'Выберите файл для загрузки'
    },
    parseResponse: {
      type: Function,
      default: v => v
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    name: null,
    busy: false,
    progress: 0
  }),

  methods: {
    async upload(file) {
      if (this.busy) return
      this.busy = true

      this.$emit('upload-start')

      let formdata = new FormData()
      formdata.append('jsonscheme', file, file.name)

      try {
        let response = await http.post('/files/upload/scheme', formdata, {
          onUploadProgress: progressEvent => {
            let totalLength = progressEvent.lengthComputable
              ? progressEvent.total
              : progressEvent.target.getResponseHeader('content-length') ||
                progressEvent.target.getResponseHeader(
                  'x-decompressed-content-length'
                )
            if (totalLength !== null) {
              let progress = Math.round(
                (progressEvent.loaded * 100) / totalLength
              )
              this.progress = progress
              this.$emit('upload-progress', progress)
            }
          }
        })
        if (response.data) {
          this.$emit('input', this.parseResponse(response.data))
          this.$emit('upload-success', response.data)
        } else {
          this.$emit('upload-error', 'Непредвиденная ошибка')
        }
      } catch (error) {
        this.$emit('upload-error', error)
      }

      this.busy = false
      this.progress = 0
    },

    read(event) {
      let file = event.target.files[0]

      if (file) {
        this.name = file.name
        this.$refs.form.reset()
        this.upload(file)
      } else {
        this.$root.showSnack('Неподдерживаемый формат файла')
      }
    },

    remove() {
      if (this.value) {
        this.$emit('remove-file', this.value)
        http.delete(`/files/delete/${this.value.hash}`)
      } else {
        throw 'No such file'
      }
    }
  }
}
</script>

<style scoped>
.file-upload-wrap {
  overflow: hidden;
  position: relative;
}
.file-upload [type='file'] {
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 50px;
  position: absolute;
}
.file {
  display: flex;
  padding-left: 33px;
  align-items: center;
}
.name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.file-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.file-preview {
  margin: 24px 0 48px 0;
}
.file-preview img {
  max-width: 100%;
  height: 200px;
  display: block;
}
.file-remove {
  margin-top: 12px;
}
.file-remove a {
  text-decoration: underline;
}
</style>
